import { AnimatedCurrency } from 'components/member_onboarding_v2/components/AnimatedCurrency'
import { SkeletonItem } from 'components/reusable/SkeletonItem'
import { UnderlinedTooltip } from 'components/ui/UnderlinedTooltip'
import { formatMoney } from 'utils'

import { QuoteCostDetails } from './QuoteCostDetails'
import { useSelfServeExplorerContext } from './QuoteSelfServeExplorerContext'

interface QuoteCostBreakdownProps {
  showStaticValue?: boolean
}

export const QuoteCostBreakdown = ({ showStaticValue = false }: QuoteCostBreakdownProps) => {
  const {
    totalEmployerCost,
    isLoading,
  } = useSelfServeExplorerContext()

  const renderTotalCost = () => {
    if (isLoading) {
      return <SkeletonItem widthClass='w-32' heightClass='h-8' />
    }

    if (showStaticValue) {
      return <span>{formatMoney(totalEmployerCost)}</span>
    }

    return <AnimatedCurrency value={totalEmployerCost} />
  }

  return (
    <div className='p-6'>
      <UnderlinedTooltip className='w-fit mb-1' content='The estimated total that will be billed to you each month'>
        <h3 className='body'>Estimated total monthly cost</h3>
      </UnderlinedTooltip>
      <div className='heading-xl text-gray-800 font-medium mb-4'>
        {renderTotalCost()}
      </div>
      <QuoteCostDetails />
    </div>
  )
}
